import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, TablePagination, Box, Checkbox, Button, Typography, LinearProgress } from '@mui/material';
import { useLocations } from '../../../../shared/context/locationsContext';
import { useUtiles } from '../../../../shared/context/utilesContext';
import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router'
import DeleteIcon from '@mui/icons-material/Delete';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function ListLocationsComponent() {

    const { locations, loadingLocations, getLocations, pagination, setPagination,  resetLocation, deleteLocation, loadingDeleteLocation, selectedLocationsToDelete, setSelectedLocationsToDelete } = useLocations()
    const { locationString } = useUtiles()
    const theme = useTheme()
    const navigate = useNavigate()

    const ability = useAbility();

    useEffect(() => {
        getLocations()  
        resetLocation()
    }, [])
 



    const handleCheckboxChange = (id) => {
        setSelectedLocationsToDelete(prev => {
            if (prev.includes(id)) {
                return prev.filter(itemId => itemId !== id);
            } else {
                return [...prev, id];
            }
        });
    };




    return (
        <>
          
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1, bgcolor: 'background.paper', borderRadius: '10px' }}>
                    <Typography variant="body1">
                        {selectedLocationsToDelete.length} {selectedLocationsToDelete.length === 1 ? 'elemento seleccionado' : 'elementos seleccionados'}
                    </Typography>
                   {ability.can('delete', 'ASSETS.LOCATIONS') && <Button 
                            disabled={selectedLocationsToDelete.length === 0 || loadingDeleteLocation}
                            size="small"
                            variant="contained" 
                            color="error" 
                            startIcon={<DeleteIcon />}
                            onClick={() => {
                                deleteLocation(selectedLocationsToDelete)
                            }}
                        >
                            Eliminar seleccionados
                        </Button>}
                </Box>
                {loadingLocations && (
                    <LinearProgress />
                )}
    
            <TableContainer component={Paper} sx={{ "&.MuiPaper-root": { borderRadius: '10px', boxShadow: 'none' }, height: '70vh', overflow: 'auto' }}>
                <Table sx={{ minWidth: 2500, overflowX: 'auto' }} aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '50px' }}>
                                {ability.can('delete', 'ASSETS.LOCATIONS') && <Checkbox 
                                    color="secondary" 
                                    checked={locations.length > 0 && selectedLocationsToDelete.length === locations.length}
                                    indeterminate={selectedLocationsToDelete.length > 0 && selectedLocationsToDelete.length < locations.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedLocationsToDelete(locations.map(loc => loc.id));
                                        } else {
                                            setSelectedLocationsToDelete([]);
                                        }
                                    }}
                                />}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Habilitado</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '150px' }}>Fuera de servicio</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '260px' }}>Código</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '400px' }}>Descripción</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Nombre</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '300px' }}>Dirección</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '400px' }}>Ciudad / Departamento / Pais</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Clasificación 1</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Clasificación 2</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '450px' }}>Ubicación</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {locations.map((location, index) => (
                            <TableRow key={index} onClick={() => ability.can('update', 'ASSETS.LOCATIONS') && navigate(`/activos/ubicaciones/update/${location.hash_code}`)} sx={{ cursor: 'pointer' }}>

                                <TableCell onClick={(e) => e.stopPropagation()}>
                                    {ability.can('delete', 'ASSETS.LOCATIONS') && <Checkbox 
                                            color="secondary"  
                                            checked={selectedLocationsToDelete.includes(location.id)}
                                            onChange={(e) => handleCheckboxChange(location.id)}
                                        />}
                                </TableCell>

                                <TableCell>
                                    {location.enabled ?
                                        <Chip label="SI"
                                            sx={{
                                                backgroundColor: theme.palette.success.main,
                                                color: "#fff", fontWeight: 'bold'
                                            }}></Chip> :
                                        <Chip label="NO" sx={{
                                            backgroundColor: theme.palette.warning.main,
                                            color: theme.palette.warning.contrastText, fontWeight: 'bold'
                                        }}></Chip>
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.out_of_service ?
                                            <Chip label="SI"
                                                sx={{
                                                    backgroundColor: theme.palette.error.main,
                                                    color: theme.palette.error.contrastText, fontWeight: 'bold'
                                                }}></Chip> :
                                            <Chip label="NO" sx={{
                                                backgroundColor: theme.palette.success.main,
                                                color: "#fff", fontWeight: 'bold'
                                            }}></Chip>
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.code
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.description
                                    }

                                </TableCell>
                                <TableCell>
                                    {
                                        location.name
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.address
                                    }
                                </TableCell>

                                <TableCell>
                                    {
                                        location.city + ' / ' + location.state + ' / ' + location.country
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.classification1?.value
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        location.classification2?.value
                                    }
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                    {locationString(location.parent)}
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2,  }}>
                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component="div"
                    count={pagination.count || 0}
                    rowsPerPage={pagination.per_page || 20}
                    page={(pagination.current_page || 0) - 1}
                    onPageChange={(event, newPage) => {
                        console.log(pagination)
                        setPagination({ ...pagination, current_page: newPage });
                        getLocations({ ...pagination, page: newPage + 1 });
                    }}
                    onRowsPerPageChange={(event) => {
                        setPagination({ ...pagination, per_page: parseInt(event.target.value) });
                        getLocations({ ...pagination, page: 1, per_page: event.target.value });
                    }}
                    labelRowsPerPage="Registros por página"
                    sx={{
                        "& .MuiTablePagination-root": {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            mt: 2
                        }
                    }}
                />
            </Box>
        </>
    )
}